// Content for Śrīmad-Bhāgavatam 1.5.19 - The Indestructible Taste of Bhakti

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Śrīmad-Bhāgavatam 1.5.19',
        sloka: `na vai jano jātu kathañcanāvrajen
mukunda-sevy anyavad aṅga saṁsṛtim |
smaran mukundāṅghry-upagūhanaṁ punar
vihātum icchen na rasa-graho janaḥ ||`,
        translation:
            'Oh (<strong>aṅga</strong>)! The person (<strong>janaḥ</strong>) who serves Mukunda (<strong>mukunda-sevī</strong>) will never under any condition (<strong>jātu kathañcana</strong>) return to the material world (<strong>na vai āvrajet saṁsṛtim</strong>), unlike practitioners of other processes (<strong>anya-vat</strong>). Remembering (<strong>smaran</strong>) the embrace of the Lord’s lotus feet (<strong>mukunda-aṅghri-upagūhanam</strong>), eager for that taste he has experienced (<strong>rasa-grahaḥ</strong>), he will not desire to give up those feet again (<strong>punaḥ vihātum icchet na janaḥ</strong>).',
    },
    blocks: [
        {
            type: 'text',
            content:
                'This verse elaborates the point that there is no misfortune for the devotee. Even if overcome because of poor determination, the person who serves Mukunda never (<em>na jātu</em>), returns to <em>saṁsāra</em>, the place for enjoying the results of <em>karma</em>, whereas those practicing <em>karma</em> (anyavat) return. That is because he does not experience happiness and distress from karmas, since he experiences only the fruit of happiness and distress directly given by the Lord.',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Śrīmad-Bhāgavatam 10.87.40',
                sloka: 'tvad avagamī na vetti bhavad-uttha-śubhāśubhayor',
                translation:
                    'When a person realizes You, he no longer cares about his good and bad fortune arising from past pious and sinful acts, since it is You alone who control this good and bad fortune.',
            },
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Padma Purāṇa',
                sloka: 'na karma-bandhanam janma vaiṣṇavānām ca vidyate',
                translation: 'The Vaiṣṇavas do not have rebirth caused by <em>karma</em>.',
            },
        },
        {
            type: 'text',
            content:
                'Remembering from previous practice alone the mental embrace (<em>upagūhanam</em>) of the Lord’s lotus feet, he has no desire to give that up. The verse does not say “remembering his lotus feet” but rather “remembering the embrace of his lotus feet.” And the word “again” is used. The implication of these two words is that even though he may give up by his own choice the worship, once, twice or three times because of poor determination, after some time, by remembering his previous state of bliss from remembering the Lord and also remembering his present state of distress from not remembering the Lord, he repents. <strong>“Oh! Oh! What have I foolishly done? Let that be. I will not again abandon worship of Lord.”</strong> He again begins worshipping the Lord.',
        },
        {
            type: 'text',
            content:
                'The verse also uses the phrase <strong>“does not desire to give up” instead of “does not give up.”</strong> This implies that he desires that he be devoid of pride in his practice. The accomplishment is in the hands of the Lord. The cause of not desiring to give up is then mentioned. Rasa-graha means one who is eager for tasting, or one who has a taste which is something like a ghost which cannot be given up, “haunted by <em>rasa</em>.” The meaning is then that worship after the stages of <em>niṣthā</em>, ruci and <em>āsakti</em>, becomes actual <em>rasa</em> at the stage of rati. <strong>However, even from the first day of worshipping the Lord, there is certainly a portion of tasting <em>rasa</em> in a very covered form.</strong> Thus it is said:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Śrīmad-Bhāgavatam 11.2.42',
                sloka: `bhaktiḥ pareśānubhavo viraktir
anyatra caiṣa trika eka-kālaḥ
prapadyamānasya yathāśnataḥ syus
tuṣṭiḥ puṣṭiḥ kṣud-apāyo 'nu-ghāsam`,
                translation:
                    'Devotion, direct experience of the Supreme Lord, and detachment from other things-these three occur simultaneously for one who has taken shelter of Kṛṣṇa, in the same way that pleasure, fullness of the stomach and relief from hunger are experienced simultaneously, with each bite, for a person engaged in eating.',
            },
        },
    ],
};

export default content;